import * as React from 'react';

import dynamic from 'next/dynamic';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { ListingDetailsContext } from '../../ListingDetailsContext';

import styles from './map.module.css';

const DynamicOpenStreetMap = dynamic(
  () => import('./OpenstreetMap').then(({ OpenStreetMap }) => OpenStreetMap),
  { ssr: false },
);

export const Map = () => {
  const { T } = useIntl();
  const { listingDetails } = ListingDetailsContext.useContext();

  if (!listingDetails.postalCode) {
    return null;
  }

  return (
    <div id="map" className={styles.root}>
      <Typography className={CommonStyles.margin_bottom_2} variant="h5">
        {T('ldp.where_you_stay')}
      </Typography>
      <Typography className={CommonStyles.margin_bottom_2} variant="body2">
        {`${listingDetails.computedStreetName}, ${listingDetails.computedCityName}`}
      </Typography>
      <DynamicOpenStreetMap />
    </div>
  );
};
